var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.678,
    height: 33.611,
    viewBox: "0 0 33.678 33.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.788,0H2.891A2.869,2.869,0,0,0,0,2.891v27.9a2.855,2.855,0,0,0,2.891,2.823h27.9a2.912,2.912,0,0,0,2.891-2.891V2.891A2.957,2.957,0,0,0,30.788,0ZM13.444,25.544A11.5,11.5,0,0,1,7.26,23.729,4.438,4.438,0,0,0,8.2,23.8a8.328,8.328,0,0,0,5.042-1.748,4.061,4.061,0,0,1-3.832-2.756,2.757,2.757,0,0,0,.739.067,5.884,5.884,0,0,0,1.076-.134,3.988,3.988,0,0,1-3.159-3.966v-.067a4.089,4.089,0,0,0,1.815.538,4.079,4.079,0,0,1-1.815-3.361A3.919,3.919,0,0,1,8.6,10.352a11.157,11.157,0,0,0,8.335,4.235,2.45,2.45,0,0,1-.134-1.008,4,4,0,0,1,4.033-4.033,4.226,4.226,0,0,1,2.891,1.21,8.323,8.323,0,0,0,2.554-.941A4.231,4.231,0,0,1,24.536,12.1a5.905,5.905,0,0,0,2.353-.672,5.507,5.507,0,0,1-1.882,2.084A11.525,11.525,0,0,1,13.444,25.544Z",
    fill: "#222f3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f36f60ddd342da9de146df6686e4600a.svg";
export { ForwardRef as ReactComponent };